export default "__VITE_ASSET__BLdjfpg___"